import React, { useState,useEffect } from "react";
import { Table } from "react-bootstrap";
import { BsDownload } from "react-icons/bs";
import { toast } from "react-toastify";

export const DocumentDownloadList = ({data_documents, occupationColumn}) => {
//   const documents = [
//     { id: 1, name: "Manual [EN].pdf.pdf", download_link: "#" },
//     { id: 2, name: "react.pdf.pdf", download_link: "#" },
//     { id: 3, name: "Metal Fitter and Machinists (n.e.c).docx", download_link: "#" },
//   ];
const [documents, setDocuments] = useState(data_documents || []);

// useEffect(() => {
//   setDocuments(data_documents || []);
//   console.log("Documents updated:", data_documents);
// }, [occupationColumn]);

const handleDownload = (link, name) => {
    if (link) {
      const downloadLink = document.createElement("a");
      downloadLink.href = link;
      downloadLink.setAttribute("target", "_blank");
      downloadLink.click();
      toast.success(`Downloaded Opened PDF of ${name}!`);
    } else {
      toast.error(`Failed to download ${name}. Link not available.`);
    }
  };

  return (
    <div className="table-responsive table-wrapper">
      <Table striped hover className="dataTable no-footer" style={{ cursor: "default" }}>
        <thead>
          <tr>
            <th scope="col" className="col-1 th_font_size">Sr.No.</th>
            {(occupationColumn == true) && (
              <>
              <th scope="col" className="th_font_size">Occupation</th>
              <th scope="col" className="col-2 th_font_size">ANZSCO CODE</th>
            </>
            )}
            {(occupationColumn == false) && (
            <th scope="col" className="th_font_size">Document Name</th>
            )}
            <th scope="col" className="col-1 th_font_size text-center">Action</th>
          </tr>
        </thead>
        <tbody>
        {(documents || []).length === 0 && (
            <tr>
            <td colSpan={(occupationColumn == true) ? "3" : "3"} className="text-center td_font_size">
                No documents available for download.
            </td>
            </tr>
        )}

          {documents.map((doc, index) => (
            <tr key={doc?.id} className={index % 2 === 0 ? "even" : "odd"}>
              <td className="td_font_size">{index + 1}.</td>
              {(occupationColumn == true) && (
                <>
                <td className="td_font_size">
                    {doc?.occupation_name}
                </td>

                <td className="td_font_size">
                    {doc?.occupation_number}
                </td>
              </>
              )}

              {(occupationColumn == false) && (
              <td className="td_font_size">
                {/* <a
                  href={doc?.download_link}
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    cursor: "pointer",
                    color: "blue",
                    textDecoration: "none",
                  }}
                > */}
                  {doc?.name}
                {/* </a> */}
              </td>
              )}
              <td className="td_font_size">
                <div className="btn-container">
                  <button
                  onClick={() => {
                    if(occupationColumn == true){
                        handleDownload(doc?.download_link,doc?.occupation_name)
                    }
                    else{
                        handleDownload(doc?.download_link,doc?.name)
                    }
                    
                  }}
                    className="btn btn-sm edit mx-auto"
                    style={{
                      backgroundColor: "#055837",
                      color: "#fecc00",
                      marginRight: "8px",
                      transition: "background-color 0.2s, color 0.2s",
                    }}
                  >
                    <BsDownload size={16} />
                  </button>
                </div>
              </td>
            </tr>
          ))}
        </tbody>
      </Table>
    </div>
  );
};
